import { Directive, Input, OnChanges, SimpleChanges, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { random } from 'lodash-es';

import { SkeletonComponent } from './skeleton.component';

@Directive({
  selector: '[skeleton]',
  standalone: true,
})
export class SkeletonDirective implements OnChanges {
  private tpl = inject<TemplateRef<any>>(TemplateRef);
  private vcr = inject(ViewContainerRef);

  @Input('skeleton') public isLoading = false;
  @Input('skeletonWidth') public width: string;
  @Input('skeletonHeight') public height: string;

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.isLoading) {
      this.vcr.clear();

      if (changes.isLoading.currentValue) {
        const ref = this.vcr.createComponent(SkeletonComponent);

        Object.assign(ref.instance, {
          width: this.width === 'rand' ? `${random(50, 90)}%` : this.width,
          height: this.height,
        });
      } else {
        this.vcr.createEmbeddedView(this.tpl);
      }
    }
  }
}
